import { render, staticRenderFns } from "./addDistribution.vue?vue&type=template&id=b0f4bea8&scoped=true"
import script from "./addDistribution.vue?vue&type=script&lang=js"
export * from "./addDistribution.vue?vue&type=script&lang=js"
import style0 from "./addDistribution.vue?vue&type=style&index=0&id=b0f4bea8&prod&scoped=scoped&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0f4bea8",
  null
  
)

export default component.exports